import { Controller } from "@hotwired/stimulus"

// Sichtbares Feedback fuer leere Pflicht-Custom-Fields.
//
// Problem (Tester 11.09.): Ist ein Custom-Field als `required` definiert und leer,
// blockiert die HTML5-Validierung den GESAMTEN Formular-Submit — aber STILL: das
// ungueltige Feld liegt oft ausserhalb des Sichtbereichs, die native Browser-
// Sprechblase erscheint nicht (bei TomSelect-Feldern ist das <select> zudem
// versteckt). Fuer den Nutzer sieht es aus, als wuerde "Speichern" nichts tun.
//
// Der Controller haengt an der Custom-Fields-Sektion, faengt die `invalid`-Events
// der Felder ab (bubbeln nicht -> Capture), scrollt zum ersten ungueltigen Feld,
// markiert es rot und blendet eine Hinweiszeile ein. Beim Ausfuellen verschwindet
// die Markierung wieder.
export default class extends Controller {
  connect() {
    this._onInvalid = this.onInvalid.bind(this)
    this._onFixed = this.clearError.bind(this)
    this.element.addEventListener("invalid", this._onInvalid, true)
    this.element.addEventListener("input", this._onFixed, true)
    this.element.addEventListener("change", this._onFixed, true)
  }

  disconnect() {
    this.element.removeEventListener("invalid", this._onInvalid, true)
    this.element.removeEventListener("input", this._onFixed, true)
    this.element.removeEventListener("change", this._onFixed, true)
  }

  onInvalid(event) {
    const field = event.target
    this.markError(field)
    // Nur zum ERSTEN ungueltigen Feld dieses Submit-Versuchs scrollen/fokussieren.
    if (this._scrolledThisTick) return
    this._scrolledThisTick = true
    requestAnimationFrame(() => { this._scrolledThisTick = false })
    this.visibleTarget(field).scrollIntoView({ behavior: "smooth", block: "center" })
    try { field.focus({ preventScroll: true }) } catch (e) { /* versteckte Selects */ }
  }

  clearError(event) {
    const field = event.target
    if (!field.willValidate || typeof field.checkValidity !== "function") return
    if (!field.checkValidity()) return
    const cell = field.closest(".df-cp-field")
    if (!cell) return
    this.visibleTarget(field).classList.remove("ring-2", "ring-red-400", "rounded-md")
    cell.querySelector(".df-cp-error")?.remove()
  }

  markError(field) {
    const cell = field.closest(".df-cp-field")
    if (!cell) return
    this.visibleTarget(field).classList.add("ring-2", "ring-red-400", "rounded-md")
    if (!cell.querySelector(".df-cp-error")) {
      const msg = document.createElement("p")
      msg.className = "df-cp-error mt-1 text-sm text-red-600"
      msg.textContent = field.validationMessage || "Bitte dieses Pflichtfeld ausfüllen."
      cell.appendChild(msg)
    }
  }

  // Bei TomSelect ist das eigentliche <select> versteckt -> auf den sichtbaren
  // .ts-wrapper zielen, sonst auf das Feld selbst.
  visibleTarget(field) {
    const ts = field.closest("[data-controller~='tomselect-search']")
    return (ts && ts.querySelector(".ts-wrapper")) || field
  }
}
